import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="py-10 md:py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                <i className="ri-book-open-line"></i>
              </span>
              <span className="text-lg font-heading text-foreground-950">亲亲漫画</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              按地域精选韩漫、日漫、国漫热门推荐，海量免费漫画在线全集下拉式阅读，好看的漫画大全不间断更新。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/remen" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  热门推荐
                </Link>
              </li>
              <li>
                <Link to="/category/hanman" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  韩漫精选
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-xs"></i>
                </span>
                <span>contact@qinqinmanga.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-customer-service-2-line text-xs"></i>
                </span>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors duration-200 cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="py-4 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 亲亲漫画 qinqinmanga.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}